import React from "react";
import './book-page.css';
import TheBigShort from '../../Images/books/TheBigShort.jpg';



const  Review9 = () => {
  return (
            <div className="book-page-box">
                <div class="book-header ">
                   <div className="book-img">
                   <img src={TheBigShort} alt="The Big Short "/>
                  
                  
                   </div>
                   
                   <div class="book-title">
                 <h1>The Big Short: Inside the Doomsday Machine</h1> 
       <p class="author">by <i>Michael Lewis</i></p>
         
       <p>  Book review by <i>Arni Goyal</i></p>
           
                </div>
                  
                <div className="blog-para">
                <p>
                    
                    <div className="blog-para">
                    Every once in a while, we come across a book that opens our eyes to a reality we tend to overlook or don’t fully understand. The Big Short: Inside the Doomsday Machine by Michael Lewis is one such book. It dives deep into the 2008 financial crisis, a global disaster that shook economies, ruined lives, and revealed the shocking greed and negligence of the financial world.
                
                    <br></br><br></br>
                    <h3>The Financial World Uncovered</h3>
                    To be honest, the financial world has always been a mystery to most of us. Terms like "subprime mortgages," "credit default swaps," or "mortgage-backed securities" sound intimidating, don’t they? But Lewis breaks it down in such a way that even a beginner can follow along. The story isn’t just about numbers and technicalities, it’s about the people who saw the disaster coming and tried to take a stand against it. 
                    <br></br><br></br>
                    
                    <h3>Heroes or Opportunists? </h3> 
                    The book revolves around outsiders like Michael Burry, Steve Eisman, and Greg Lippmann. These were the people who bet against the housing market when everyone else was blindly confident. Were they heroes? Opportunists? Or just smarter than the rest? That’s for the reader to decide. 
                    <br></br><br></br>
                    
                    <h3>A Lesson in Greed and Ignorance </h3> 
                    Lewis doesn’t shy away from pointing fingers at the financial industry. The arrogance, greed, and complete disregard for consequences are laid bare. While reading, one can’t help but think, "How could they let this happen?" The bigger question is, have we learned anything since then?  
                    <br></br><br></br>
                    
                    <h3>Key Takeaways </h3> 
                    <ul>
                        <li>
                        The 2008 financial crisis was fuelled by unchecked greed and ignorance in the financial world.
                        </li>

                        <li>
                        A small group of outsiders identified the cracks in the system and bet against it, risking everything. 
                        </li>
                        
                        <li>
                        Complex financial products, like mortgage-backed securities, were poorly understood and dangerously misused.  
                        </li>

                        <li>
                        The collapse exposed a lack of accountability and ethical failures across the financial industry.  
                        </li>

                        <li>
                        While some made fortunes by predicting the crisis, millions suffered devastating consequences.
                        </li>

                    </ul>

                    <br/>
                    
                    <h3>Final Thoughts  </h3> 
                    What makes The Big Short stand out is its mix of technical details and human stories. It’s not just a book about finance, it’s about understanding human behaviour, ambition, and the price of ignoring reality.  <br></br>

                    In the end, this book leaves you with a bittersweet feeling. The people who predicted the collapse made fortunes, but at what cost? Millions lost their jobs, homes, and savings. The book is both a warning and a lesson, one we can’t afford to forget.  <br></br>
                    So, is The Big Short worth your time? Absolutely. It’s a gripping story about a disaster that could have been avoided if only the right people had paid attention.

                    </div>


                    </p>


                        </div>
                        </div>
                        </div>


                         
  );
}

export default Review9;
